import React from 'react';
import { Col, Row, Switch } from 'antd';
import Panel from '../../../../../../shared/components/card/Panel';
import HISSearchRedesign from '../BeneficiarySearch/HISSearchRedesign';
import FormSelect from '../../../../../../shared/components/crmFormElement/FormSelect/FormSelect';
import { ReactComponent as  HIS_Search_Icon} from '../../../../../../assets/images/svg/HIS_Search_Icon.svg';
import { ReactComponent as HIS_Search_Deactivated_Icon } from '../../../../../../assets/images/svg/HIS_Deactivated_Icon.svg';
import { ReactComponent as  DownArrow} from '../../../../../../assets/images/svg/DownArrow.svg';
import { BlinkingElement } from '../../../../../../shared/components/blinkingElement/blinkingElement';
import { ReactComponent as  LockedIcon} from '../../../../../../assets/images/svg/Locked.svg';

const HISSearchPanel = ({
    isHISSearchActivated,
    isHISFields,
    changeHospInfoSearch,
    handleActivation,
    HISOption,
    baseForm,
    handleHISSearchSuccess,
    handleHISSearchError,
    isHISSearchEnabled,
    GUTTOR_SPACE,
    isLoading,
    setSelectedOption,
    resetMultipleSteps,
    resetHISForm,
    onChange,
  }: any): any => (

    <Panel className={`NA-payerDropDownPanel ${!isHISSearchActivated ? 'HIS-Panel' : 'HIS-panel-activated'}`}>
      <Row className={`HISSearchRow ${!isHISSearchActivated ? 'HIS-row-panel' : ''}`}>
        <Col
          md={isHISSearchEnabled ? 7 : 17}
          lg={isHISSearchEnabled ? 7 : 18}
          xl={isHISSearchEnabled ? 7 : 20}
        >
          <div className="HIS-icon-div">
            {isHISSearchActivated ? <HIS_Search_Icon /> : <HIS_Search_Deactivated_Icon />}
            {isHISSearchEnabled ?
              <h3 className="HIS-Search-Text">HIS Search</h3>
              : <>
                <span className="Request-HIS-content">
                  Automate workflows and keep your HIS updated with real-time claim updates.</span>
                <span className="Request-HIS-contact">Contact: </span>
                <a href="mailto:provider@ihx.in">
                  <span className="Request-HIS-link">provider@ihx.in</span>
                </a>
              </>
            }
          </div>
        </Col>
        <Col
          xs={4}
          xl={isHISSearchEnabled ? 3 : 4}
          xxl={isHISSearchEnabled ? 2 : 4}
        >
          {isHISSearchEnabled ?
            <Switch
              className={`HISActivationToggle ${isHISSearchActivated ? 'activated' : 'deactivated'}`}
              checked={isHISSearchActivated}
              onChange={handleActivation}
              checkedChildren="Activated"
              unCheckedChildren="Deactivated"
              disabled={!isHISSearchEnabled}
            />
            : <BlinkingElement className="ml-blinking-element" color="#FF9807">
                <div className="HIS-disable-icon">
                  <LockedIcon/>
                  <span className="HIS-disable-icon-text">HIS Search Locked</span>
                </div>
              </BlinkingElement>}
        </Col>
      </Row>
      {isHISSearchEnabled && isHISSearchActivated && (
        <Row gutter={GUTTOR_SPACE} className="HIS-search-type">
          <Col md={9} className="his-dropdown">
            <FormSelect
              detail={{
                required: true,
                isLoading,
                hideLabel: false,
                form: baseForm,
                key: 'Fetch Patient Information from HIS',
                options: isHISFields ? isHISFields : [],
                showSearch: false,
                allowClear: false,
                visible: true,
                placeholder: 'Select HIS Search',
                onChange: (event: any): any => changeHospInfoSearch(event),
                className: 'his-select',
                isRedesign: true,
                suffixIcon: <DownArrow />,
              }}
            />
          </Col>
          <Col md={14} xxl={15}>
            <HISSearchRedesign
              selectedHISOption={HISOption}
              form={baseForm}
              onSearchSuccess={handleHISSearchSuccess}
              onSearchError={handleHISSearchError}
              setSelectedOption={setSelectedOption}
              resetMultipleSteps={resetMultipleSteps}
              resetHISForm={resetHISForm}
              onFieldChange={onChange}
            />
          </Col>
        </Row>
      )}
    </Panel>
  );

export default HISSearchPanel;
